import { ObalMaterialu } from '../../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchObalMaterialuVseobecnyInitData,
} from '../../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import Uuid from '../../../../model/Uuid';

interface ReturnType {
  obalInitData: ObalMaterialu;
  initDataStatus: ClientStatus;
}

export default (
  type: string,
  year: number,
  index: number,
  stadiumUuid: Uuid,
  stadium: StadiumMaterialuEnum,
): ReturnType => {
  const {
    data: obalInitData,
    status: initDataStatus,
  } = useClientFetch(fetchObalMaterialuVseobecnyInitData, [type, year, index, stadiumUuid, stadium], []);
  return {
    obalInitData,
    initDataStatus,
  };
};
